import { Component, input, output } from '@angular/core';

import { InvalidEnabledField } from 'src/app/utils/form-validation.helper';

@Component({
  selector: 'app-invalid-field-badges',
  templateUrl: './invalid-field-badges.component.html',
  styleUrls: ['./invalid-field-badges.component.scss']
})
export class InvalidFieldBadgesComponent {
  readonly invalidFields = input<InvalidEnabledField[]>([]);
  readonly fieldSelected = output<string>();

  selectField(fieldName: string): void {
    this.fieldSelected.emit(fieldName);
  }
}
